import { toastErroCarregar } from "./toastErroCarregar";
import { isNullOrEmpty } from "./isNullOrEmpty";
import { inicializarInternacionalizacao } from "../localizacao/global/global";
import i18next from "i18next";

export async function validarResultado(retorno, callbackSucesso, callbackErro, callbackErroConexao, exibirToastErroConexao = true, exibirToastErroServidor = true) {
    if (retorno.status != 200) {

        if (exibirToastErroConexao) {
            inicializarInternacionalizacao()
            toastErroCarregar(i18next.t('ErroConexaoGenerico'));
        }

        return callbackErroConexao ? callbackErroConexao() : null;
    }

    const resultados = await retorno.json();

    if (resultados.sucesso || resultados.Sucesso) {
        return callbackSucesso ? callbackSucesso(resultados) : null;
    }

    const mensagemErro = resultados.mensagem || resultados.Mensagem;
    if (exibirToastErroServidor && !isNullOrEmpty(mensagemErro))
        toastErroCarregar(mensagemErro);

    return callbackErro ? callbackErro(resultados) : null;



}
